enum LINES_ALLOWED {
  MAIN_HEADER_TITLE = 10,
  MAIN_HEADER_SUBTITLE = 1,
  MAIN_HEADER_DESCRIPTION = 3,
  MAIN_EPISODE_DESCRIPTION = 2,
  MAIN_EPISODE_TITLE = 1,
  EPISODE_HEADER_PODCAST_TITLE = 1,
  EPISODE_HEADER_EPISODE_TITLE = 10,
}

enum MOBILE_LINES_ALLOWED {
  MAIN_EPISODE_TITLE = 2,
}

enum LINE_HEIGHT {
  DEFAULT = 1.5,
  EPISODE_PAGE_TEXT = 1.6,
  TITLE = 1.3,
}

enum FIXED_FONT_SIZE {
  META_INFO = 14,
  EPISODE_LABEL = 12,
}

const LINK_HOVER_OPACITY = 0.8;

export {
  LINES_ALLOWED,
  MOBILE_LINES_ALLOWED,
  LINE_HEIGHT,
  FIXED_FONT_SIZE,
  LINK_HOVER_OPACITY,
};
